module.exports = __webpack_public_path__ + "img/hc_pro_five_2.7891ffa4.jpg";